import request from '@/router/axios';

const baseUrl = "/ds_login"

// 用户名密码登录
export const login_by_username = (obj) => request({
    url: baseUrl+ '/admin_login_check',
    method: 'post',
    data: obj
});

// 根据 token 获得用户信息
export const get_userinfo = (params) => request({
    url: baseUrl+ '/setting/info',
    method: 'get',
    params: params
});

// 注册 参数： email 邮箱   password 密码   full_name 姓名  invite_code 邀请码   yhlb 用户类别（"0" 学生 "1" 教师）
export const register = (obj) => request({
    url: baseUrl+ '/user/register',
    method: 'post',
    data: obj
});


